// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"fc685f2e","551":"262b8bfa","940":"c041b19d"}[chunkId] + ".chunk.js";
};